import styled from "styled-components";

export const Container = styled.div`
  width: 100vw;
  height: 70vh;
  display: flex;
  position: relative;
  overflow: hidden;

  @media only screen and (max-width: 760px) {
    height: 330px;
  } ;
`;
export const Arrow = styled.div`
  width: 50px;
  height: 50px;
  background-color: #00ffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: ${(props) => props.direction === "left" && "10px"};
  right: ${(props) => props.direction === "right" && "10px"};
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
`;
export const Wrapper = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 1.5s ease;
  transform: translateX(${(props) => props.slideIndex * -100}vw);
`;
export const Slide = styled.div`
  display: flex;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #${(props) => props.bg};
`;

export const Imgcontainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex: 1;
`;

export const InfoContainer = styled.div`
  flex: 1;
  padding: 50px;
`;
export const Title = styled.h1`
  font-size: 70px;
  @media only screen and (max-width: 760px) {
    font-size: 30px;
  }
`;
export const Desc = styled.p`
  margin: 50px 0px;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 3px;
  @media only screen and (max-width: 760px) {
    font-size: 13px;
  }
`;

export const Image = styled.img`
  height: 50%;
  border-radius: 7px;
  @media only screen and (max-width: 760px) {
    height: 150px;
    margin: 7px;
    align-self: center;
  }
`;
